export function BlogPostSkeleton() {
  return (
    <div className="flex flex-col overflow-hidden rounded-xl border border-border/30 bg-card">
      <div className="aspect-[16/10] animate-pulse bg-muted/50" />
      <div className="flex flex-1 flex-col p-5">
        <div className="mb-3 h-2.5 w-16 animate-pulse rounded-full bg-muted/50" />
        <div className="mb-2 h-5 w-4/5 animate-pulse rounded bg-muted/50" />
        <div className="mb-1 h-3 w-full animate-pulse rounded bg-muted/40" />
        <div className="mb-5 h-3 w-3/5 animate-pulse rounded bg-muted/40" />
        <div className="border-t border-border/30 pt-4">
          <div className="h-3 w-28 animate-pulse rounded bg-muted/40" />
        </div>
      </div>
    </div>
  );
}
